import { Hashtag } from './hashtag';

export * from './hashtag';

export default Hashtag;
